import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const AvailabilitiesQuery = gql`
  query ($domain: String!) {
    availabilities(where: { eshop: { domain: $domain }}) {
      id
      title
      color
      name
      default
      watchDogAction
      allowedActions
      schemaOrg
      excludeFromSitemap
    }
    languages {
      id
      value
    }
  }
`;

const CreateAvailabilityMutation = gql`
  mutation($availability: CreateAvailabilityInput!) {
    createAvailability(availability: $availability) {
      id
    }
  }
`;

const UpdateAvailabilityMutation = gql`
  mutation($id: String!, $availability: UpdateAvailabilityInput!) {
    updateAvailability(id: $id, availability: $availability) {
      id
    }
  }
`;

const DeleteAvailabilityMutation = gql`
  mutation($id: String!) {
    deleteAvailability(id: $id) {
      id
    }
  }
`;

interface IInputProps {
  children?: any;
}

interface Response {
  data: any;
}

class GetAvailabilitiesQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
  render() {
    const {
      availabilities,
      createAvailability,
      updateAvailability,
      deleteAvailability
    }: any = this.props;
    return this.props.children({
      availabilities,
      createAvailability,
      updateAvailability,
      deleteAvailability
    });
  }
}

export default compose(
  graphql<IInputProps, Response>(AvailabilitiesQuery, {
    name: 'availabilities'
  }),
  graphql<IInputProps, Response>(CreateAvailabilityMutation, {
    name: 'createAvailability'
  }),
  graphql<IInputProps, Response>(UpdateAvailabilityMutation, {
    name: 'updateAvailability'
  }),
  graphql<IInputProps, Response>(DeleteAvailabilityMutation, {
    name: 'deleteAvailability'
  })
)(GetAvailabilitiesQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Availabilities/Availabilities.tsx